export enum TheatreCancelDialogType {
  Stay = 1,
  ClearChanges = 2,
  Save = 3
}
